export const cookiesClient = {
  add(name: string, value: any, expiration: number = 0, path?: string): void {
    if (typeof document === 'undefined') {
      return;
    }

    const expires: Date = new Date(new Date().getTime() + expiration);
    const pathVariable: string = path ? `path=${path}` : '';

    document.cookie = `${name}=${value}; expires=${expires}; ${pathVariable}`;
  },

  remove(name: string, path?: string): void {
    if (typeof document === 'undefined') {
      return;
    }

    const expires: Date = new Date(0);
    const pathVariable: string = path ? `path=${path}` : '';

    document.cookie = `${name}=; expires=${expires}; ${pathVariable}`;
  },

  get(cookieName: string): string {
    if (typeof document === 'undefined') {
      return '';
    }

    const name: string = `${cookieName}=`;
    const allCookies: string[] = document.cookie.split(';');

    for (let cookie of allCookies) {
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return '';
  },
};
